/**
 * Truncates text to a specified length and adds ellipsis if needed
 * @param text - The text to truncate
 * @param maxLength - Maximum length before truncation (default: 30)
 * @param ellipsis - String to append when truncated (default: '...')
 * @returns Truncated text with ellipsis or original text if within limit
 */
export const truncateText = (
  text: string,
  maxLength: number = 30,
  ellipsis: string = '...'
): string => {
  if (text.length <= maxLength) {
    return text;
  }

  const truncateLength = maxLength - ellipsis.length;
  return `${text.slice(0, truncateLength)}${ellipsis}`;
};
